import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SignRoutes() {
  const location = useLocation();
  const { isAuth } = useAuth();
  return isAuth ? <Navigate to={location.state?.from || "/"} /> : <Outlet />;
}
